import {getPaddingsClassFromData, getPropSafely} from "@/utils/utils";
import Gallery from "@/components/gallery/Gallery";
import useFilterData from "@/hooks/useFIlterData";

export default function GalleryModule({ data, isPreview }) {
	const id = data?.id || ''
	const paddings = getPaddingsClassFromData(data)
	const images = data?.assets?.images || []
	const allGalleries = getPropSafely(data, 'galleries', [])
	const contextData = useFilterData(allGalleries, false)
	const assets = contextData?.assets?.images || [];
	return (
		<>
			{contextData && isPreview && (
				<Gallery id={id} className={paddings} assets={assets}/>
			)}
			{!isPreview && (<Gallery id={id} className={paddings} assets={images}/>)}
		</>
	)
}
